import _definePage_default_0 from '/home/enon/Desktop/EER Prototip/eer-diagram-oop/src/pages/[...path].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/enon/Desktop/EER Prototip/eer-diagram-oop/src/pages/index.vue'),
    children: [
      {
        path: '',
        name: '//',
        component: () => import('/home/enon/Desktop/EER Prototip/eer-diagram-oop/src/pages/index/index.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/:path(.*)',
    name: 'CatchAllPage',
    component: () => import('/home/enon/Desktop/EER Prototip/eer-diagram-oop/src/pages/[...path].vue'),
    /* no children */
  },
  _definePage_default_0
  )
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

